
import { Switch, Form, Input, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from "react-i18next"

const AddressForm = ({ formValues, form }) => {
    const { t } = useTranslation();
    
    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="tooltip" label={t("Tooltip")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label="" name="helpText">
                    <TextArea rows={2} placeholder={t("Enter help text")} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t("Mandatory")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t("Read Only")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="mapEnabled" label={t("Map Enabled")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            
        </>
    )
}

export default AddressForm